/**
* @author Edgar Escobedo
* @description Filtra un array de objetos y evita que haya elementos repetidos
* @updatedDate 30-05-2023
* @param {Number} number 
* @returns {Array}
*/
const arrObjNoRepetElements = (arrayElments, key) => {
    const filterArray = [...new Map(arrayElments.map(item =>
        [item[key], item])).values()];

    return filterArray
}

/**
* @author Edgar Escobedo
* @description Filtra un array y evita que haya elementos repetidos
* @updatedDate 30-05-2023
* @param {Number} number 
* @returns {Array}
*/
const arrNoRepetElements = (arrayElments, key) => {
    const filterArray = new Set(arrayElments);
    const arrayNoElementsRepeat = Array.from(filterArray)

    return arrayNoElementsRepeat
}

/**
* @author Edgar Escobedo
* @description Parse entities
* @updatedDate 10-06-2024
* @param {Object} entities 
* @returns {Array}
*/
const parseEntities = (entitiesJson, t) => {
    let entities = []
    let keys = Object.keys(entitiesJson)
    keys.map((key) => {
        entitiesJson[key].map(entity => {
            let type = ''
            switch (key) {
                case 'DATE':
                    type = t("parseEntities.date")
                    break;
                case 'GPE':
                    type = t("parseEntities.gpe")
                    break;
                case 'LAW':
                    type = t("parseEntities.law")
                    break;
                case 'MONEY':
                    type = t("parseEntities.money")
                    break;
                case 'ORG':
                    type = t("parseEntities.org")
                    break;
                case 'PERCENT':
                    type = t("parseEntities.percent")
                    break;
                case 'PERSON':
                    type = t("parseEntities.person")
                    break;
                case 'PRODUCT':
                    type = t("parseEntities.product")
                    break;
                case 'ORDINA':
                    type = t("parseEntities.ordinal")
                    break;
                case 'CARDINAL':
                    type = t("parseEntities.cardinal")
                    break;
                // default:
                //     type=t("parseEntities.others")
                //     break;
            }
            let data = {
                type,
                name: entity
            }

            entities.push(data)
        })
    })
    return entities
}

/**
* @author Edgar Escobedo
* @description Filter files pdf
* @updatedDate 01-11-2024
* @param {Object} files 
* @returns {Array}
*/
const filterFilesPDF = (files) => {
    return files.filter(file => {
        return file.type === 'application/pdf';
    });
}

export { arrObjNoRepetElements, arrNoRepetElements, parseEntities, filterFilesPDF }